module.exports = __webpack_public_path__ + "assets/img/0fb640f701baefe80a064fa90d9ceab5.svg";